
import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import { useAuth } from '../../hooks/useAuth';

// FIXED: Use the exact same photo mapping system as Today's Sales and MTD Sales pages
const profilePhotos: { [key: string]: string } = {
  // AJ Santiago variations
  aj: 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  'aj santiago':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  AJ: 'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  'AJ Santiago':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f2329cfbcf33ae9b0f2d8a91c6da9b69.png',
  // Adrian Medrano variations
  adrian:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  'adrian medrano':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  Adrian:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  'Adrian Medrano':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/1cfddd0c323faee2e871d38fa787a874.png',
  // Alex/Alexander Lara variations
  alex:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  alexander:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'alex lara':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'alexander lara':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  Alex:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  Alexander:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alex Lara':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  'Alexander Lara':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/9506a91e2b948a80a95df4f717459f04.png',
  // Fernando Bochas variations
  fernando:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  'fernando bochas':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  Fernando:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  'Fernando Bochas':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/ca3a7c70ce6454b10b56db8c687bdb75.png',
  // Jeff/Jeffrey Wilson variations
  jeff:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  jeffrey:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'jeff wilson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'jeffrey wilson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  Jeff:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  Jeffrey:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeff Wilson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  'Jeffrey Wilson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/4992c88e639f7fa3308eca513522c5b1.png',
  // Jenny/Jennyrose Arvizu variations
  jenny:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  jennyrose:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'jenny arvizu':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'jennyrose arvizu':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  Jenny:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  Jennyrose:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jenny Arvizu':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  'Jennyrose Arvizu':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/38a681727cc72d08123d7abd82cb55f3.png',
  // Jesse Cheguina variations
  jesse:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  'jesse cheguina':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  Jesse:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  'Jesse Cheguina':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/7d761e0dd331f2381c412ba047eb3c0a.png',
  // Paul Sims variations
  paul:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  'paul sims':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  Paul:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  'Paul Sims':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/09fe48f131ff9b7d3d07da969b285d32.png',
  // Shan/Shanitan Harrell variations
  shan:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  shanitan:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'shan harrell':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'shanitan harrell':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  Shan:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  Shanitan:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shan Harrell':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  'Shanitan Harrell':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/96dcddae3106e07139a385ae3570b561.png',
  // Steven Simpson variations
  steven:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  'steven simpson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  Steven:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  'Steven Simpson':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/958a53a03973a40f1fd7d402c4e31057.png',
  // Yesenia Pena variations
  yesenia:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  'yesenia pena':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  Yesenia:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  'Yesenia Pena':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/6952c9d71aed10b00d0b21770a6d2ee4.png',
  // Yulisa Pena variations
  yulisa:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  'yulisa pena':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  Yulisa:
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
  'Yulisa Pena':
    'https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/2bde41cba6dac6240f8e8c37ff03ce3a.png',
};

// FIXED: Use the exact same photo matching function as Today's Sales and MTD Sales pages
const getProfilePhoto = (employeeName: string): string | null => {
  if (!employeeName || typeof employeeName !== 'string') {
    console.log('❌ Invalid employee name:', employeeName);
    return null;
  }

  console.log(`\n🔍 === SEARCHING FOR PHOTO: "${employeeName}" ===`);

  if (profilePhotos[employeeName]) {
    console.log(`✅ EXACT MATCH FOUND: "${employeeName}" -> ${profilePhotos[employeeName]}`);
    return profilePhotos[employeeName];
  }

  const lowerName = employeeName.toLowerCase();
  if (profilePhotos[lowerName]) {
    console.log(`✅ LOWERCASE MATCH FOUND: "${lowerName}" -> ${profilePhotos[lowerName]}`);
    return profilePhotos[lowerName];
  }

  const firstName = employeeName.split(' ')[0];
  if (profilePhotos[firstName]) {
    console.log(`✅ FIRST NAME MATCH FOUND: "${firstName}" -> ${profilePhotos[firstName]}`);
    return profilePhotos[firstName];
  }

  const firstNameLower = firstName.toLowerCase();
  if (profilePhotos[firstNameLower]) {
    console.log(`✅ FIRST NAME LOWERCASE MATCH FOUND: "${firstNameLower}" -> ${profilePhotos[firstNameLower]}`);
    return profilePhotos[firstNameLower];
  }

  console.log(`❌ NO PHOTO FOUND for: "${employeeName}"`);
  console.log(`🔍 Available keys:`, Object.keys(profilePhotos).slice(0, 10));
  return null;
};

// Helper function to parse numeric values from strings
const parseNumeric = (value: any): number => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const cleaned = value.replace(/[$,]/g, '');
    const parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
  }
  return 0;
};

// Export default function TVView
export default function TVView() {
  const { user } = useAuth();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const [slideInterval, setSlideInterval] = useState(40);
  const [tempInterval, setTempInterval] = useState('40');

  const [currentTime, setCurrentTime] = useState(new Date());
  const [slidesData, setSlidesData] = useState<any[]>([]);

  // Update time every second
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Page refresh every 2 minutes
  useEffect(() => {
    const refreshTimer = setInterval(() => {
      window.location.reload();
    }, 120000);
    return () => clearInterval(refreshTimer);
  }, []);

  // Fetch data from Supabase tables directly
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);

        // Fetch data from all 4 Supabase tables
        const [
          { data: phSalesTodayData, error: phSalesTodayError },
          { data: todaysSalesData, error: todaysSalesError },
          { data: mtdSalesData, error: mtdSalesError },
          { data: phSalesData, error: phSalesError },
        ] = await Promise.all([
          supabase.from('philippines_sales_today_data').select('*'),
          supabase.from('todays_sales_data').select('*'),
          supabase.from('mtd_sales_data').select('*'),
          supabase.from('philippines_sales_data').select('*'),
        ]);

        console.log('📊 RAW DATA FROM TABLES:');
        console.log('PH Sales Today:', phSalesTodayData);
        console.log('Todays Sales:', todaysSalesData);
        console.log('MTD Sales:', mtdSalesData);
        console.log('PH Sales MTD:', phSalesData);

        // Helper function to count working days (Monday-Friday only)
        const getWorkingDays = () => {
          const now = new Date();
          const year = now.getFullYear();
          const month = now.getMonth();
          const currentDay = now.getDate();
          
          let workingDays = 0;
          for (let day = 1; day <= currentDay; day++) {
            const date = new Date(year, month, day);
            const dayOfWeek = date.getDay();
            // 0 = Sunday, 6 = Saturday
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
              workingDays++;
            }
          }
          
          console.log(`📅 Working days calculation: ${workingDays} working days out of ${currentDay} calendar days`);
          return workingDays;
        };

        // Helper to process each dataset
        const processData = (data: any[], error: any, slideName: string) => {
          if (error) {
            console.error(`❌ Error fetching ${slideName}:`, error);
            return { title: slideName, employees: [], stats: {} };
          }

          if (!data || data.length === 0) {
            console.log(`⚠️ No data found for ${slideName}`);
            return { title: slideName, employees: [], stats: {} };
          }

          console.log(`\n🔍 === PROCESSING ${slideName.toUpperCase()} ===`);
          console.log(`Raw data rows: ${data.length}`);

          // Find Total row - check ALL possible field name variations
          const totalRow = data.find(row => {
            const nameFields = [
              row.sales_agent,
              row.agent_name,
              row.employee_name,
              row.name,
              row.Agent,
              row.Employee,
              row.underwriting_assistant,
              row['Sales Agent'],
              row['Agent Name'],
              row['Employee Name'],
            ];
            const hasTotal = nameFields.some(
              field => field && field.toString().toLowerCase().includes('total')
            );
            if (hasTotal) {
              console.log(`✅ Found Total row in ${slideName}:`, row);
            }
            return hasTotal;
          });

          // Filter out Total row to get employees only
          const employees = data.filter(row => {
            const nameFields = [
              row.sales_agent,
              row.agent_name,
              row.employee_name,
              row.name,
              row.Agent,
              row.Employee,
              row.underwriting_assistant,
              row['Sales Agent'],
              row['Agent Name'],
              row['Employee Name'],
            ];
            return !nameFields.some(
              field => field && field.toString().toLowerCase().includes('total')
            );
          });

          console.log(`👥 Employees found: ${employees.length}`);

          // Parse stats from Total row or calculate from employees
          let stats = {};
          if (totalRow) {
            console.log(`📊 Using Total row for ${slideName} stats`);
            
            // Try ALL possible field name variations for each stat
            const totalPolicies = parseNumeric(
              totalRow.policies_sold ??
                totalRow.policies ??
                totalRow.orders ??
                totalRow.Policies ??
                totalRow['Policies Sold'] ??
                totalRow['Policies'] ??
                0
            );

            const brokerFeeTotal = parseNumeric(
              totalRow.broker_fee_total ??
                totalRow.bf_total ??
                totalRow.broker_fee ??
                totalRow.brokerFee ??
                totalRow.sales ??
                totalRow.revenue ??
                totalRow['Broker Fee Total'] ??
                totalRow['BF Total'] ??
                totalRow['Broker Fee'] ??
                0
            );

            const bfAverage = parseNumeric(
              totalRow.broker_fee_average ??
                totalRow.bf_average ??
                totalRow['BF Average'] ??
                totalRow['Broker Fee Average'] ??
                0
            );

            const roadsideTotal = parseNumeric(
              totalRow.roadside ??
                totalRow.roadside_sold ??
                totalRow.roadsides ??
                totalRow['Roadside'] ??
                totalRow['Roadside Sold'] ??
                totalRow['Roadsides'] ??
                0
            );

            // Calculate BF Average if not provided in Total row
            const calculatedBFAverage = bfAverage > 0 ? bfAverage : (totalPolicies > 0 ? Math.round(brokerFeeTotal / totalPolicies) : 0);

            // Calculate per day average for MTD slides using working days
            let soldPerDayAvg = 0;
            if (slideName.includes('MTD')) {
              const workingDays = getWorkingDays();
              soldPerDayAvg = workingDays > 0 ? Math.round(totalPolicies / workingDays) : 0;
              console.log(`📈 ${slideName} Per Day Avg: ${totalPolicies} policies ÷ ${workingDays} working days = ${soldPerDayAvg}`);
            }

            stats = {
              totalPoliciesSold: totalPolicies,
              brokerFeeTotal: brokerFeeTotal,
              bfAverage: calculatedBFAverage,
              roadsideServiceSold: roadsideTotal,
              soldPerDayAvg: soldPerDayAvg,
            };

            console.log(`✅ ${slideName} stats from Total row:`, stats);
          } else {
            console.log(`⚠️ No Total row found for ${slideName}, calculating from employees`);
            
            // Calculate from employees if no Total row
            const totalPolicies = employees.reduce((sum, emp) => {
              return (
                sum +
                parseNumeric(
                  emp.policies_sold ??
                    emp.policies ??
                    emp.orders ??
                    emp.Policies ??
                    emp['Policies Sold'] ??
                    emp['Policies'] ??
                    0
                )
              );
            }, 0);

            const brokerFeeTotal = employees.reduce((sum, emp) => {
              return (
                sum +
                parseNumeric(
                  emp.broker_fee_total ??
                    emp.bf_total ??
                    emp.broker_fee ??
                    emp.brokerFee ??
                    emp.sales ??
                    emp.revenue ??
                    emp['Broker Fee Total'] ??
                    emp['BF Total'] ??
                    emp['Broker Fee'] ??
                    0
                )
              );
            }, 0);

            const roadsideTotal = employees.reduce((sum, emp) => {
              return (
                sum +
                parseNumeric(
                  emp.roadside ??
                    emp.roadside_sold ??
                    emp.roadsides ??
                    emp['Roadside'] ??
                    emp['Roadside Sold'] ??
                    emp['Roadsides'] ??
                    0
                )
              );
            }, 0);

            const bfAverage = totalPolicies > 0 ? Math.round(brokerFeeTotal / totalPolicies) : 0;

            // Calculate per day average for MTD slides using working days
            let soldPerDayAvg = 0;
            if (slideName.includes('MTD')) {
              const workingDays = getWorkingDays();
              soldPerDayAvg = workingDays > 0 ? Math.round(totalPolicies / workingDays) : 0;
              console.log(`📈 ${slideName} Per Day Avg: ${totalPolicies} policies ÷ ${workingDays} working days = ${soldPerDayAvg}`);
            }

            stats = {
              totalPoliciesSold: totalPolicies,
              brokerFeeTotal: brokerFeeTotal,
              bfAverage: bfAverage,
              roadsideServiceSold: roadsideTotal,
              soldPerDayAvg: soldPerDayAvg,
            };

            console.log(`✅ ${slideName} stats calculated from employees:`, stats);
          }

          return { title: slideName, employees, stats };
        };

        const resolvedSlides = [
          processData(phSalesTodayData || [], phSalesTodayError, 'PH Sales Today'),
          processData(todaysSalesData || [], todaysSalesError, "Today's Sales"),
          processData(mtdSalesData || [], mtdSalesError, 'MTD Sales'),
          processData(phSalesData || [], phSalesError, 'PH Sales MTD'),
        ];

        setSlidesData(resolvedSlides);
        console.log('\n✅ ALL SLIDES DATA LOADED:', resolvedSlides);
      } catch (error) {
        console.error('❌ Error fetching TV view data:', error);
        setSlidesData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  // FIXED: Auto-advance slides - only when not paused and has data
  useEffect(() => {
    if (isPaused || slidesData.length === 0 || loading) {
      return;
    }

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    }, slideInterval * 1000);

    return () => clearInterval(timer);
  }, [isPaused, slideInterval, slidesData.length, loading]);

  // Employee Card Component
  function EmployeeCard({ employee, rank }: { employee: any; rank: number }) {
    const getRankColor = (rank: number) => {
      if (rank === 1) return 'bg-gradient-to-br from-yellow-400 to-yellow-500 border-yellow-300';
      if (rank === 2) return 'bg-gradient-to-br from-gray-300 to-gray-400 border-gray-300';
      if (rank === 3) return 'bg-gradient-to-br from-amber-600 to-amber-700 border-amber-500';
      return 'bg-white border-green-200';
    };

    const getRankIcon = (rank: number) => {
      if (rank === 1) return 'ri-trophy-fill text-white';
      if (rank === 2) return 'ri-medal-fill text-white';
      if (rank === 3) return 'ri-award-fill text-white';
      return 'ri-user-line text-green-600';
    };

    const getTextColor = (rank: number) => {
      if (rank <= 3) return 'text-white';
      return 'text-gray-900';
    };

    // Handle all possible name field variations including PH Sales Today
    const employeeName =
      employee.employee_name ??
      employee.name ??
      employee.agent_name ??
      employee.sales_agent ??
      employee.Agent ??
      employee.underwriting_assistant ?? // Added for PH Sales Today
      'Unknown Employee';

    // FIXED: Use the same photo matching system as Today's Sales and MTD Sales pages
    const employeePhoto = getProfilePhoto(employeeName);

    // Parse values using the helper function - handle PH Sales Today field names
    const policies = parseNumeric(employee.policies_sold ?? employee.policies ?? employee.orders ?? 0);
    const brokerFee = parseNumeric(employee.broker_fee_total ?? employee.brokerFee ?? employee.sales ?? employee.broker_fee ?? employee.revenue ?? employee.bf_total ?? 0);
    const roadside = parseNumeric(employee.roadside ?? employee.roadside_sold ?? employee.roadsides ?? 0); // Added roadsides field

    // Calculate BF Average correctly: Broker Fee Total / Policies Sold
    const brokerFeeAverage = policies > 0 ? Math.round(brokerFee / policies) : 0;

    return (
      <div
        className={`rounded-lg border-2 p-4 shadow-lg hover:shadow-xl transition-all duration-300 ${getRankColor(
          rank,
        )}`}
      >
        <div className="flex items-center space-x-3 mb-3">
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center overflow-hidden ${
              rank <= 3 ? 'bg-white bg-opacity-20' : 'bg-green-100'
            }`}
          >
            {employeePhoto ? (
              <img
                src={employeePhoto}
                alt={employeeName}
                className="w-full h-full object-cover"
                onError={e => {
                  console.log(`❌ Failed to load photo for ${employeeName}:`, employeePhoto);
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.innerHTML = `<i class="${getRankIcon(rank)} text-lg"></i>`;
                  }
                }}
              />
            ) : (
              <i className={`${getRankIcon(rank)} text-lg`}></i>
            )}
          </div>
          <div className="flex-1 min-w-0">
            <h3 className={`text-base font-bold truncate ${getTextColor(rank)}`}>{employeeName}</h3>
            <p className={`text-sm ${rank <= 3 ? 'text-white text-opacity-80' : 'text-gray-600'}`}>
              Rank #{rank}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <span className={`text-sm font-medium ${getTextColor(rank)}`}>Policies:</span>
            <span className={`text-base font-bold ${getTextColor(rank)} flex items-center`}>
              {policies === 0 && <span className="mr-1">💩</span>}
              {policies.toLocaleString()}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className={`text-sm font-medium ${getTextColor(rank)}`}>Broker Fee:</span>
            <span className={`text-base font-bold ${getTextColor(rank)}`}>${brokerFee.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center">
            <span className={`text-sm font-medium ${getTextColor(rank)}`}>BF Average:</span>
            <span className={`text-base font-bold ${getTextColor(rank)} flex items-center`}>
              {brokerFeeAverage < 135 && <span className="mr-1">💩</span>}
              ${brokerFeeAverage.toLocaleString()}
            </span>
          </div>
          <div className="flex justify-between items-center">
            <span className={`text-sm font-medium ${getTextColor(rank)}`}>Roadside:</span>
            <span className={`text-base font-bold ${getTextColor(rank)}`}>{roadside.toLocaleString()}</span>
          </div>
        </div>
      </div>
    );
  }

  // Calculate totals for current slide
  const getCurrentSlideTotals = () => {
    const current = slidesData[currentSlide];
    if (!current?.employees) {
      return {
        totalPolicies: 0,
        totalBrokerFee: 0,
        totalBFAverage: 0,
        totalRoadsides: 0,
        soldPerDayAvg: 0,
      };
    }

    // Use stats from processed data
    const totalPolicies = current.stats?.totalPoliciesSold || 0;
    const totalBrokerFee = current.stats?.brokerFeeTotal || 0;
    const totalBFAverage = current.stats?.bfAverage || 0;
    const totalRoadsides = current.stats?.roadsideServiceSold || 0;
    const soldPerDayAvg = current.stats?.soldPerDayAvg || 0;

    return { totalPolicies, totalBrokerFee, totalBFAverage, totalRoadsides, soldPerDayAvg };
  };

  // Get current slide data and totals
  const currentSlideData = slidesData[currentSlide] || { title: '', employees: [] };
  const sortedEmployees = currentSlideData.employees
    ? [...currentSlideData.employees].sort((a, b) => {
        // Ranking: 1) Policies first, 2) BF Average second
        const aPolicies = parseNumeric(
          a.policies_sold ?? 
          a.policies ?? 
          a.orders ?? 
          a.Policies ?? 
          a['Policies Sold'] ?? 
          a['Policies'] ?? 
          0
        );
        const bPolicies = parseNumeric(
          b.policies_sold ?? 
          b.policies ?? 
          b.orders ?? 
          b.Policies ?? 
          b['Policies Sold'] ?? 
          b['Policies'] ?? 
          0
        );

        if (aPolicies !== bPolicies) {
          return bPolicies - aPolicies;
        }

        const aBrokerFee = parseNumeric(
          a.broker_fee_total ?? 
          a.brokerFee ?? 
          a.sales ?? 
          a.broker_fee ?? 
          a.revenue ?? 
          a.bf_total ?? 
          a['Broker Fee Total'] ?? 
          a['BF Total'] ?? 
          a['Broker Fee'] ?? 
          0
        );
        const aBFAverage = aPolicies > 0 ? Math.round(aBrokerFee / aPolicies) : 0;

        const bBrokerFee = parseNumeric(
          b.broker_fee_total ?? 
          b.brokerFee ?? 
          b.sales ?? 
          b.broker_fee ?? 
          b.revenue ?? 
          b.bf_total ?? 
          b['Broker Fee Total'] ?? 
          b['BF Total'] ?? 
          b['Broker Fee'] ?? 
          0
        );
        const bBFAverage = bPolicies > 0 ? Math.round(bBrokerFee / bPolicies) : 0;

        return bBFAverage - aBFAverage;
      })
    : [];

  const currentTotals = getCurrentSlideTotals();

  // Get slide-specific background colors
  const getSlideBackgroundColor = (slideIndex: number) => {
    const colors = [
      'from-purple-100 to-purple-200',
      'from-green-101 to-green-200',
      'from-blue-100 to-blue-200',
      'from-orange-100 to-orange-200',
    ];
    return colors[slideIndex] || 'from-gray-100 to-gray-200';
  };

  // Get slide-specific accent colors
  const getSlideAccentColor = (slideIndex: number) => {
    const colors = [
      { primary: 'purple-600', secondary: 'purple-200', text: 'purple-700' },
      { primary: 'green-600', secondary: 'green-200', text: 'green-700' },
      { primary: 'blue-600', secondary: 'blue-200', text: 'blue-700' },
      { primary: 'orange-600', secondary: 'orange-200', text: 'orange-700' },
    ];
    return colors[slideIndex] || { primary: 'gray-600', secondary: 'gray-200', text: 'gray-700' };
  };

  const currentSlideColors = getSlideAccentColor(currentSlide);

  const handlePausePlay = () => {
    setIsPaused(!isPaused);
  };

  const handleIntervalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setTempInterval(value);
  };

  const handleIntervalSubmit = () => {
    const newInterval = parseInt(tempInterval);
    if (!isNaN(newInterval) && newInterval >= 5 && newInterval <= 300) {
      setSlideInterval(newInterval);
    } else {
      setTempInterval(slideInterval.toString());
      alert('Please enter a valid interval between 5 and 300 seconds');
    }
  };

  const handleIntervalKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleIntervalSubmit();
    }
  };

  const handleManualSlideChange = (newSlide: number) => {
    console.log(`👆 Manual slide change from ${currentSlide} to ${newSlide}`);
    setCurrentSlide(newSlide);
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br ${getSlideBackgroundColor(currentSlide)} overflow-hidden transition-all duration-1000`}>
      {loading ? (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-16 w-16 border-b-4 border-green-600 mb-4"></div>
            <p className="text-2xl font-semibold text-gray-700">Loading TV Dashboard...</p>
            <p className="text-gray-500 mt-2">Fetching live sales data</p>
          </div>
        </div>
      ) : (
        <>
          {/* Header */}
          <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
            <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex justify-between items-center py-3">
                <div className="flex items-center space-x-4">
                  <img
                    src="https://static.readdy.ai/image/179d4a3273ef4ee52c79cd3980b80e29/f406f3425590be50bb55e9ed845c748f.png"
                    alt="Driven Insurance Services"
                    className="h-12 w-auto"
                  />
                  <div>
                    <h1 className="text-2xl font-bold text-gray-900">TV Dashboard</h1>
                    <p className="text-sm text-gray-600">Live Performance Overview</p>
                  </div>
                </div>

                {/* Totals Display */}
                <div className={`bg-white bg-opacity-90 backdrop-blur-sm rounded-xl border-2 border-${currentSlideColors.secondary} px-4 py-3 shadow-lg`}>
                  <div className="flex items-center space-x-6">
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total Policies</p>
                      <p className={`text-2xl font-black text-${currentSlideColors.text}`}>
                        {currentTotals.totalPolicies.toLocaleString()}
                      </p>
                      {currentSlideData.title.includes('MTD') && currentTotals.soldPerDayAvg > 0 && (
                        <p className="text-xs text-gray-500 mt-1">
                          {currentTotals.soldPerDayAvg.toLocaleString()} per day avg
                        </p>
                      )}
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total BF Average</p>
                      <p className={`text-xl font-bold text-${currentSlideColors.text}`}>
                        ${currentTotals.totalBFAverage.toLocaleString()}
                      </p>
                    </div>
                    <div className="text-center">
                      <p className="text-sm font-medium text-gray-600">Total Roadsides</p>
                      <p className={`text-xl font-bold text-${currentSlideColors.text}`}>
                        {currentTotals.totalRoadsides.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Time and Date */}
                <div className="text-right">
                  <div className="text-2xl font-bold text-gray-900">
                    {currentTime.toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit',
                      second: '2-digit',
                    })}
                  </div>
                  <div className="text-sm text-gray-600">
                    {currentTime.toLocaleDateString([], {
                      weekday: 'long',
                      month: 'short',
                      day: 'numeric',
                    })}
                  </div>
                </div>
              </div>
            </div>
          </header>

          {/* Main Content */}
          <div className="max-w-full mx-auto px-4 py-2">
            {/* Slide Title */}
            <div className="mb-3">
              <h2 className={`text-3xl font-bold text-${currentSlideColors.text} mb-1 text-center`}>
                {currentSlideData.title}
              </h2>
              <p className={`text-${currentSlideColors.text} text-lg text-center`}>
                Showing {sortedEmployees.length} employees • Updated live
              </p>
            </div>

            {/* Employee Grid */}
            {sortedEmployees.length > 0 ? (
              <div
                className={`grid gap-4 ${
                  (currentSlideData.title === "Today's Sales" || currentSlideData.title === 'MTD Sales')
                    ? sortedEmployees.length <= 3
                      ? 'grid-cols-3'
                      : sortedEmployees.length <= 6
                      ? 'grid-cols-3 grid-rows-2'
                      : sortedEmployees.length <= 9
                      ? 'grid-cols-3 grid-rows-3'
                      : 'grid-cols-4 grid-rows-3'
                    : sortedEmployees.length <= 6
                    ? 'grid-cols-6'
                    : sortedEmployees.length <= 8
                    ? 'grid-cols-8'
                    : sortedEmployees.length <= 10
                    ? 'grid-cols-10'
                    : sortedEmployees.length <= 12
                    ? 'grid-cols-12'
                    : 'grid-cols-6 grid-rows-3'
                }`}
              >
                {sortedEmployees.map((employee, index) => (
                  <EmployeeCard key={index} employee={employee} rank={index + 1} />
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <i className={`ri-user-line text-6xl text-${currentSlideColors.primary} mb-4`}></i>
                <p className={`text-${currentSlideColors.text} text-2xl`}>
                  No employee data available for this slide
                </p>
              </div>
            )}

            {/* Slide Navigation */}
            <div className="flex justify-center items-center mt-4 mb-2">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handleManualSlideChange((currentSlide - 1 + slidesData.length) % slidesData.length)}
                  className={`w-12 h-12 bg-${currentSlideColors.primary} text-white rounded-full flex items-center justify-center hover:bg-${currentSlideColors.primary.replace(
                    '600',
                    '700',
                  )} transition-colors shadow-lg`}
                >
                  <i className="ri-arrow-left-line text-lg"></i>
                </button>

                <div className="flex space-x-2">
                  {slidesData.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => handleManualSlideChange(idx)}
                      className={`w-3 h-3 rounded-full transition-colors ${
                        idx === currentSlide
                          ? `bg-${currentSlideColors.primary}`
                          : `bg-${currentSlideColors.secondary}`
                      }`}
                      aria-label={`Go to slide ${idx + 1}`}
                    />
                  ))}
                </div>

                <button
                  onClick={() => handleManualSlideChange((currentSlide + 1) % slidesData.length)}
                  className={`w-12 h-12 bg-${currentSlideColors.primary} text-white rounded-full flex items-center justify-center hover:bg-${currentSlideColors.primary.replace(
                    '600',
                    '700',
                  )} transition-colors shadow-lg`}
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>

                <button
                  onClick={handlePausePlay}
                  className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors shadow-lg ml-2"
                  title={isPaused ? 'Resume slideshow' : 'Pause slideshow'}
                >
                  <i className={`${isPaused ? 'ri-play-fill' : 'ri-pause-fill'} text-lg`}></i>
                </button>

                {/* Time Interval Control */}
                <div
                  className={`flex items-center space-x-2 bg-white bg-opacity-90 backdrop-blur-sm rounded-full px-4 py-2 border border-${currentSlideColors.secondary} shadow-lg ml-2`}
                >
                  <i className={`ri-timer-line text-${currentSlideColors.primary} text-sm`}></i>
                  <input
                    type="number"
                    value={tempInterval}
                    onChange={handleIntervalChange}
                    onKeyPress={handleIntervalKeyPress}
                    onBlur={handleIntervalSubmit}
                    min="5"
                    max="300"
                    className={`w-12 text-center text-sm font-medium text-${currentSlideColors.text} bg-transparent border-none outline-none`}
                    title="Slide interval in seconds (5-300)"
                  />
                  <span className={`text-xs text-${currentSlideColors.primary} font-medium`}>sec</span>
                </div>
              </div>
            </div>

            {/* Auto-advance indicator */}
            <div className="text-center">
              <div
                className={`inline-flex items-center space-x-2 bg-white bg-opacity-80 backdrop-blur-sm rounded-full px-4 py-2 border border-${currentSlideColors.secondary}`}
              >
                <i
                  className={`${
                    isPaused ? 'ri-pause-line' : 'ri-time-line'
                  } text-sm ${isPaused ? 'text-blue-600' : `text-${currentSlideColors.primary}`}`}
                ></i>
                <span className={`text-sm text-${currentSlideColors.text}`}>
                  {isPaused
                    ? 'Slideshow paused'
                    : `Auto-advancing every ${slideInterval} seconds`} • Page refreshes every 2 minutes
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
